import { createContext, useState } from "react";

export const CrudCooperatedContext = createContext()

export function CrudCooperatedProvider({ children, ...rest }) {
  const [genderV, setGender] = useState('');
  const [inputValueGender, setInputValueGender] = useState('');

  const [doctype, setDoctype] = useState();
  const [inputValueDoc, setInputValueDoc] = useState('');

  const [contactType, setContact] = useState('');
  const [inputValueContact, setInputValueContact] = useState('');

  const [incomes, setIncomes] = useState('');

  const [status, setStatus] = useState('');
  const [inputStatus, setInputStatus] = useState('');

  const [situationDocument, setSituationDocument] = useState('');
  const [inputSituationDocument, setInputSituationDocument] = useState('');

  const [reason, setReason] = useState('');

  const [pa, setPa] = useState('');
  const [inputPa, setInputPa] = useState('');

  const [paV, setPaV] = useState('');

  const [documents, setDocuments] = useState(false);
  
  return (
    <CrudCooperatedContext.Provider
      value={{
        genderV,
        setGender,
        inputValueGender,
        setInputValueGender,
        doctype,
        setDoctype,
        inputValueDoc,
        setInputValueDoc,
        contactType,
        setContact,
        inputValueContact,
        setInputValueContact,
        status,
        setStatus,
        inputStatus,
        setInputStatus,
        situationDocument,
        setSituationDocument,
        inputSituationDocument,
        setInputSituationDocument,
        reason,
        setReason,
        setIncomes,
        incomes,
        pa,
        setPa,
        inputPa,
        setInputPa,
        paV,
        setPaV,
        documents,
        setDocuments,
      }}
    >
      {children}
    </CrudCooperatedContext.Provider>
  )
}